import React, { FC } from 'react';

import Select, { SelectProps } from 'components/Select';

import { optionsConfig } from 'components/PackageStatus';
import { PackageStatus } from '__generated__/PackageStatus_package.graphql';

const keys: PackageStatus[] = ['DRAFT', 'EXPIRED', 'PUBLISHED', 'WAITING'];

type Props = {
  name: string;
} & SelectProps;

const PackageStatusSelect: FC<Props> = props => (
  <Select {...props} keys={keys} optionsConfig={optionsConfig} />
);

export default PackageStatusSelect;
